// The strip's closed slot as the bar holds it, drawn still: the bar's own surface and hairline around the chip.
.bar {
    display: flex;
    max-width: 360px;
    padding: 10px 14px;
    background: var(--ov-panel);
    border: 1px solid var(--proof-border-strong);
    border-radius: 16px;
}
